export default {
  buttonClick: 'ButtonClick',
  virtualPageView: 'VirtualPageview',
  accountTypes: {
    pj: 'company',
    pf: 'personal',
    driver: 'driver'
  }
};
